const houseNumbers = document.querySelectorAll('.showcase__number');
const tabContents = document.querySelectorAll('.js-tabs-list > *');
const tabNavItems = document.querySelectorAll('.tabs__nav > div');

houseNumbers.forEach((house, index) => {
  house.addEventListener('click', (e) => {
    e.preventDefault();

    if (house.classList.contains('sold')) {
      return;
    }

    const tabNav = tabNavItems[index];
    const tabContent = tabContents[index];
    if (!tabNav || !tabContent) return;

    tabNav.click();

    const offset = 160;
    const top = tabContent.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  });
});
